<template>
  <footer :class="$style.footer">
    <CopyRight />
  </footer>
</template>

<script setup lang="ts">
import CopyRight from './CopyRight.vue'
</script>

<style lang="scss" module>
.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: $color-surface-backdrop;

  &__debug {
    &:nth-child(n + 2) {
      margin-left: 8px;
    }
  }
}
</style>
